import {GridColDef} from '@mui/x-data-grid-pro'
import {ProgramsSelectOptions} from '../func/checkCodeOptions'
import {columnFragments as C} from './Fragments'

export const officeColumnMap = (
  programName: string,
  handleInputChange: any,
  activeTab: string,
  officeCode: string
): {[officeCode: string]: GridColDef[]} => ({
  // * 윔즈
  B700: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    // C.bef_check_info,
    C.bef_check_code,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  Z700: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    // C.bef_check_code,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  C100: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_code,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  Z101: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  Z102: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  3801: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  5800: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  8601: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  // * 새올
  5400: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_code,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  Z200: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_code,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  1701: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_code,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  A800: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  1900:
    activeTab === '부관'
      ? [
          C.check_date,
          C.customer_number,
          C.customer_info,
          // C.bef_check_code,
          // C.bef_check_value,
          C.bef_check_info,
          C.bef_file_path,
          C.now_check_info,
          C.file_path,
          C.check_value(handleInputChange),
          C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
          C.check_user,
          C.edited_status(officeCode),
        ]
      : [
          C.check_date,
          C.customer_number,
          C.customer_info,
          C.now_check_info,
          C.file_path,
          C.check_value(handleInputChange),
          C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
          C.check_user,
          C.edited_status(officeCode),
        ],
  7601: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  7602: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  // * 푸른물
  4700: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  5701: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  H101: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  A600: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  7001: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  D101: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  '0801': [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_code,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  7900: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_code,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  C900: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_code,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  2601: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  2602: [
    C.check_date,
    C.customer_number,
    C.customer_info,
    C.bef_check_value,
    C.bef_used,
    C.now_check_info,
    C.file_path,
    C.check_value(handleInputChange),
    C.now_used,
    C.now_check_code(ProgramsSelectOptions(programName, officeCode), handleInputChange),
    C.check_user,
    C.edited_status(officeCode),
  ],
  default: [],
})
